import React, { useEffect, Component, useState } from "react";
import Button from "@mui/material/Button";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../admin.css";
import Image from "react-bootstrap/Image";
import Sidebar from "../../SideNav/sideBar";
import Loader from "../../../Components/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { apiAdminConfig } from "../../../utils/api";
import CustomSnackbar from "../../../Components/notify/Snackbar";
import { Box, CardContent, Grid, TextField } from "@mui/material";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from '@mui/icons-material/ZoomIn';



const Contant = () => {
  let navigate = useNavigate();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [posts, setPosts] = useState([]);
  // const [doc, setDoc] = useState({});
  const [snackData, setsnackdata] = React.useState({
    open: false,
    message: "",
    status: "",
  });
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage("");
  };

  const base_urll = "https://evsexpres.com/public/assets/images/";

  // ============= Get Doctor Data ==============
  const fetchdata = async (id) => {
    setLoader(true);
    await apiAdminConfig
      .get(`api/auth/master/driver/view/${id}`)
      .then((response) => {
        if (response.status === 200) {
          setPosts(response?.data?.view_data[0]);
        }
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
    setLoader(false);
  };

  // =================== Get current Posts ===============
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPost = null;

  // posts.slice(indexOfFirstPost, indexOfLastPost);

  // ============== Change Page ===================
  const paginate = (pagenumber) => {
    setCurrentPage(pagenumber);
  };

  useEffect(() => {
    if (id) {
      fetchdata(id);
    }
  }, [id]);

  useEffect(() => {
    if (snackData.open && snackData.status == "error") {
      setTimeout(() => {
        setsnackdata({
          open: false,
          message: "",
          status: "error",
        });
      }, 3000);
    } else if (snackData.open && snackData.status == "success") {
      setTimeout(() => {
        setsnackdata({
          open: false,
          message: "",
          status: "success",
        });
      }, 1000);
    }
  }, [snackData.open]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          {<CustomSnackbar value={snackData} />}
          <Row className="mt-4">
            <Col md={6} style={{ textAlign: "left" }}>
              <h3 style={{ height: "40px" }}>Driver Details</h3>
            </Col>
            <Col md={4}></Col>
            <Col md={2} style={{ textAlign: "left" }}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                style={{
                  borderColor: "#FF7534",
                  color: "#FF7534",
                }}
                variant="outlined"
                color="success"
              >
                Back
              </Button>
            </Col>
          </Row>
          <div className="adminContant">
            <Card>
              <Card.Body style={{ minHeight: "300px" }}>
                <Row>
                  <Col sm={12} md={12}>
                    <div className="staffdetails-card">
                      <Row>
                        {/* <Col md={4}>
                          <Card
                            border="none"
                            style={{ border: "none", marginBottom: 5 }}
                          >
                            <Image
                              width="150"
                              height="150"
                              roundedCircle
                              src={`${posts?.base_url}${posts?.profile_img}`}
                              alt="staffimage.png"
                            />
                          </Card>
                        </Col> */}
                        <Col md={8}>
                          <div className="details-container">
                            <div className="details-row">
                              <div className="details-label">Driver Name:</div>
                              <div className="details-value">
                                {posts?.user_name || "N/A"}
                              </div>
                            </div>
                            <div className="details-row">
                              <div className="details-label">Email:</div>
                              <div className="details-value">
                                {posts?.email || "N/A"}
                              </div>
                            </div>
                            <div className="details-row">
                              <div className="details-label">
                                Contact Number:
                              </div>
                              <div className="details-value">
                                {posts?.mobile || "N/A"}
                              </div>
                            </div>
                            <div className="details-row">
                              <div className="details-label">Address:</div>
                              <div className="details-value">
                                {posts?.address || "N/A"}
                              </div>
                            </div>

                            <div className="details-row">
                              <div className="details-label">City:</div>
                              <div className="details-value">
                                {posts?.city || "N/A"}
                              </div>
                            </div>
                            <div className="details-row">
                              <div className="details-label">Pincode:</div>
                              <div className="details-value">
                                {posts?.zip_code || "N/A"}
                              </div>
                            </div>
                            {/* <div className="details-row">
                              <div className="details-label">Licence Date:</div>
                              <div className="details-value">
                                {posts?.license_expiry || "N/A"}
                              </div>
                            </div> */}
                            {/* <div className="details-row">
                              <div className="details-label">
                                Registration On:
                              </div>
                              <div className="details-value">
                                {posts?.license_expiry || "N/A"}
                              </div>
                            </div> */}
                            {/* add Vehicle details */}

                            {/* <div className="details-row">
                              <div className="details-label">
                                vehicle_number:
                              </div>
                              <div className="details-value">
                                {posts?.vehicle_number || "N/A"}
                              </div>
                            </div> */}

                            <div className="details-row">
                              <div className="details-label">vehicle_type:</div>
                              <div className="details-value">
                                {posts?.vehicle_type || "N/A"}
                              </div>
                            </div>

                            <div className="details-row">
                              <div className="details-label">vehicle_body:</div>
                              <div className="details-value">
                                {posts?.vehicle_body || "N/A"}
                              </div>
                            </div>
                              <div className="details-row">
                              <div className="details-label">VAT:</div>
                              <div className="details-value">
                                {posts?.company_vat || "N/A"}
                              </div>
                            </div>
                            {/* add Vehicle details end */}

                            <div className="details-row">
                              <div className="details-label"> Status:</div>
                              <div className="details-value">
                                <Button
                                  disabled
                                  size="sm"
                                  variant="success"
                                  style={
                                    posts?.status === 1
                                      ? {
                                          backgroundColor: "rgb(12 168 48)",
                                          opacity: "0.7",
                                          color: "#fff",
                                          borderColor: "#28a745",
                                          width: "10vh",
                                          fontSize: "12px",
                                          lineHeight: "1.5",
                                          borderRadius: ".2rem",
                                          padding: ".375rem .75rem",
                                        }
                                      : {
                                          backgroundColor: "#6c757d",
                                          opacity: "0.7",
                                          color: "#fff",
                                          borderColor: "#6c757d",
                                          width: "10vh",
                                          fontSize: "12px",
                                          lineHeight: "1.5",
                                          borderRadius: ".2rem",
                                          padding: ".375rem .75rem",
                                        }
                                  }
                                >
                                  {posts?.status === 1 ? "Active" : "Inactive"}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
          <Card className="mb-3">
            <CardContent>
            <Grid container spacing={2}>
            <Grid item sm={4}>
                <Box className="details-label">Vehicle Registration No.</Box>
                <Box className="details-value">
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={posts?.vehicle_cert || ""}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Box>
              </Grid>
              <Grid item sm={4}>
                <Box className="details-label">
                  NI number
                </Box>
                <Box className="details-value">
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={posts?.nationality_cert || ""}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
            </CardContent>
          </Card>
          {/* <Card>
            <CardContent>
              <Grid container>
                <Grid item sm={4}>
                  <Box className="details-label">Driver Photo</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.dvia_cert}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.dvia_cert}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                  
                </Grid>
                <Grid item sm={4}>
                  <Box className="details-label">Driver Licence Front</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.licence_front}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.licence_front}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={4}>
                  <Box className="details-label">Driver Licence Back</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.licence_back}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.licence_back}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={4}>
                  <Box className="details-label">Disclosure</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.address_proof}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.address_proof}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={4}>
                  <Box className="details-label">Insurance Certificate</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.insurance_cert}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.insurance_cert}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={4}>
                  <Box className="details-label">Transit Certificate</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.transit_cert}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.transit_cert}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>
                <Grid item sm={4}>
                  <Box className="details-label">
                    {" "}
                    Public Liability Certificate
                  </Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.liability_cert}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.liability_cert}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>

                <Grid item sm={4}>
                  <Box className="details-label">Dvia Certificate</Box>
                  <Box className="details-value">
                    <Image
                      width="150"
                      height="150"
                      roundedCircle
                      src={`${base_urll}${posts?.dvia_cert}`}
                      alt="staffimage.png"
                      onClick={() =>
                        handleImageClick(`${base_urll}${posts?.dvia_cert}`)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card> */}
          <Card>
  <CardContent>
    <Grid container>
      {/* <Grid item sm={4}>
        <Box className="details-label">Driver Photo</Box>
        <Box className="details-value">
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <Image
              width="150"
              height="150"
              roundedCircle
              src={`${base_urll}${posts?.dvia_cert}`}
              alt="staffimage.png"
              onClick={() =>
                handleImageClick(`${base_urll}${posts?.dvia_cert}`)
              }
              style={{ cursor: "pointer" }}
            />
            <ZoomInIcon
              onClick={() =>
                handleImageClick(`${base_urll}${posts?.dvia_cert}`)
              }
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: 'white',
                backgroundColor: 'rgba(0,0,0,0.6)',
                borderRadius: '50%',
                padding: '6px',
                fontSize: 30,
                cursor: 'pointer'
              }}
            />
          </Box>
        </Box>
      </Grid> */}

      {/* Repeat for each Grid item */}
      {[
        // { label: "Address Proof", src: posts?.dvia_cert},
        { label: "Driver Licence", src: posts?.licence_front },
        // { label: "Driver Licence Back", src: posts?.licence_back },
        { label: "Vehicle Image", src: posts?.v5c_cert },
        { label: "Disclosure", src: posts?.address_proof },
        { label: "Insurance Certificate", src: posts?.insurance_cert },
        { label: "Good In Transit ", src: posts?.transit_cert },
        { label: "Public Liability Certificate", src: posts?.liability_cert },
        { label: "Dvla Check code", src: posts?.dvia_cert},
      ].map((item, index) => (
        <Grid item sm={4} key={index}>
          <Box className="details-label">{item.label}</Box>
          <Box className="details-value">
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Image
                width="150"
                height="150"
                roundedCircle
                src={`${base_urll}${item.src}`}
                alt="staffimage.png"
                onClick={() =>
                  handleImageClick(`${base_urll}${item.src}`)
                }
                style={{ cursor: "pointer" }}
              />
              <ZoomInIcon
                onClick={() =>
                  handleImageClick(`${base_urll}${item.src}`)
                }
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: 'white',
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  borderRadius: '50%',
                  padding: '6px',
                  fontSize: 30,
                  cursor: 'pointer'
                }}
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </CardContent>
</Card>
          <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md">
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseModal}
              aria-label="close"
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              <img
                src={selectedImage}
                alt="Full preview"
                style={{ width: "100%", height: "auto", borderRadius: "8px" }}
              />
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};

class Doctordetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
  }
  render() {
    return (
      <div>
        {this.state.windowWidth >= 600 ? (
          <Sidebar>
            <Contant />
          </Sidebar>
        ) : (
          <div style={{ width: "95%", margin: "80px auto" }}>
            {" "}
            <Contant />
          </div>
        )}
      </div>
    );
  }
}

export default Doctordetails;
